export const NAME = 'login';
export const LOGIN_FORM = 'login-form';
